import { Link } from "react-router-dom";

// Tour T-16 (owner, 21 October 2026): "a small plus button in the top-right corner
// of that box ... when we hover over the plus sign, it should expand to an actual
// button with the text". The same control as event.clinic's W313 `.btn-add`.
//
// THE LABEL IS ALWAYS IN THE DOM, clipped at max-width 0 and opened on hover and
// on keyboard focus, so a screen reader reads it and a keyboard reaches it. It is
// the link's accessible name: never an icon-only control.
function Plus({ label }: { label: string }) {
  return (
    <>
      <svg aria-hidden="true" width="14" height="14" viewBox="0 0 16 16">
        <path d="M8 2v12M2 8h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <span className="btn-add-label">{label}</span>
    </>
  );
}

export function AddLink({ to, label }: { to: string; label: string }) {
  return (
    <Link className="btn btn-add" to={to}>
      <Plus label={label} />
    </Link>
  );
}

// The same plus for an add that opens a form in place instead of going to a page.
export function AddButton({ onClick, label, expanded }: { onClick: () => void; label: string; expanded: boolean }) {
  return (
    <button type="button" className="btn btn-add" aria-expanded={expanded} onClick={onClick}>
      <Plus label={label} />
    </button>
  );
}
